<!-- src/views/Success.vue -->
<template>
  <div class="flex flex-col items-center justify-center min-h-screen bg-theme-bg2 px-4">
    <!-- Animated Success Icon -->
    <div class="flex items-center justify-center w-20 h-20 rounded-full bg-green-100 mb-6 animate-bounce">
      <svg xmlns="http://www.w3.org/2000/svg" class="w-12 h-12 text-green-600" fill="none" viewBox="0 0 24 24"
        stroke="currentColor" stroke-width="2">
        <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
      </svg>
    </div>

    <!-- Title -->
    <h1 class="text-3xl font-bold text-theme-text mb-2">Payment Successful</h1>

    <!-- Message -->
    <p class="text-theme-text2 text-center mb-6">
      🎉 Your payment has been received, and your rental is now confirmed!
      You can track the status of your rented item in your orders dashboard.
    </p>

    <!-- Next Steps -->
    <RouterLink :to="{ name: 'Orders' }" class="px-6 py-3 rounded-2xl bg-secondary-500 text-theme-text font-medium shadow-md 
         hover:bg-neutral-900 hover:text-white transition duration-300 ease-in-out">
      View My Orders
    </RouterLink>

  </div>
</template>

<script setup>
import { onMounted } from "vue";
import { useRoute } from "vue-router";
import axios from "axios"; // ✅ you already import axios
import { useLogger } from '@/composables/useLogger';

const logger = useLogger('PaypalSuccess');
const api_base_url = import.meta.env.VITE_API_BASE_URL;
const route = useRoute();

onMounted(async () => {
  const paymentId = route.query.paymentId;
  const payerId = route.query.PayerID;

  if (paymentId && payerId) {
    try {
      // ✅ use axios instead of api
      const res = await axios.post(`${api_base_url}/api/paypal/success`, null, {
        params: { paymentId, PayerID: payerId },
        withCredentials: true,
      });
      logger.info('PayPal payment executed', { data: res.data });
    } catch (err) {
      logger.error('PayPal payment execution failed', err?.response?.data || err.message);
    }
  } else {
    logger.warn('Missing PayPal params in URL');
  }
});
</script>
